/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Features_Plan_Day_AInputs */

const en_features_plan_day_a = /** @type {(inputs: Features_Plan_Day_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Day A · Legs`)
};

const pl_features_plan_day_a = /** @type {(inputs: Features_Plan_Day_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dzień A · Nogi`)
};

/**
* | output |
* | --- |
* | "Day A · Legs" |
*
* @param {Features_Plan_Day_AInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const features_plan_day_a = /** @type {((inputs?: Features_Plan_Day_AInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Features_Plan_Day_AInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_features_plan_day_a(inputs)
	return en_features_plan_day_a(inputs)
});